import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UniDialog from '../Common/UniDialog';
import { getUserPreference } from "../../utilities/common";
import { handlePreAlertQuery, openPreAlertQuery, showAlertSnackbar } from '../../reducers/uiSlice';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TextField, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { adminServerInstance } from '../../axios/instances';
import FullscreenLoading from '../Common/FullscreenLoading';
import { operationLog } from '../../actions/commonAction';
import { transferSubbatchPrealert } from '../../actions/preAlertManagementActions';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '80vh'
    },
    container: {
        display: 'flex'
    }
}));

const FixedTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 240,
        marginLeft: 20
    },
}))(TextField);

function PreAlertQuery() {
    const classes = useStyles();
    const {t} = useTranslation('preAlertManagement');
    const dispatch = useDispatch();

    const openModal = useSelector(openPreAlertQuery);
    let userPref = getUserPreference();

    const [subBatch, setSubBatch] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if(openModal) {
            setSubBatch('');
        }
    }, [openModal])

    function handleSubmit() {
        setLoading(true);
        let params = {
            warehouse: userPref.userCity,
            sub_batch_no: subBatch
        }
        dispatch(transferSubbatchPrealert(params))
        .then((res) => {
            setLoading(false);
            dispatch(showAlertSnackbar({message: t('create_success'), type: 'success'}));
            dispatch(operationLog('', userPref.username, '', 6, `PRE_ALERT_MANAGEMENT:${subBatch}`, 'Success'))
        })
        .catch((err) => {
            setLoading(false);
            dispatch(showAlertSnackbar({message: err.message, type: 'error'}));
            dispatch(operationLog('', userPref.username, '', 6, `PRE_ALERT_MANAGEMENT:${subBatch}`, 'Failure'))
        })
    }

    return (
        <Fragment>
            <UniDialog
                title={t('title_pre_alert_management')}
                maxWidth='sm'
                disableDefaultButtons
                open={openModal}
                onClose={handleClose}
                fullWidth
            >
                <div style={{display: 'flex', flexDirection: 'column', padding: 20}}>
                    <div style={{marginBottom: 10, fontWeight: 700, fontSize: 18}}>{t('create_sub_batch_by_pre_alert')}</div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: 10}}>
                        <span>{t('sub_batch')}</span>
                        <FixedTextField
                            variant='outlined'
                            placeholder={t('input_sub_batch')}
                            onChange={(e)=>{setSubBatch(e.target.value)}}
                            value={subBatch}
                        />
                        <Button
                            variant="contained" 
                            color="primary"
                            onClick={handleSubmit}
                            disabled={!subBatch}
                            style={{marginLeft: 20}}
                        >
                            {t('submit')}
                        </Button>
                    </div>
                    <FullscreenLoading open={loading} />               
                </div>
            </UniDialog>
        </Fragment>        
    );
    /**
     * close the dialog
    */
    function handleClose() {
        dispatch(handlePreAlertQuery(false))
    }
}

export default PreAlertQuery;